import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';
import { ICollectionType } from '../types/receiveReportTypes';
import dayjs from 'dayjs';
const tableHead = [
  'Date',
  'Voucher no',
  'Cheque No',
  'Particulars',
  'Cash',
  'Bank',
];

const PrintReceivePaymentCommonCom = ({
  data,
  crOrDr,
  fromDateTodate,
  openingBalanceDate,
  openingBalanceCashAmount,
  openingBalanceBankAmount,
  onaceTimeShowOpeningBalnce,
  totalReceivePaymentTitle,
}: {
  data: ICollectionType[] | any;
  crOrDr: 'Cr' | 'Dr';
  fromDateTodate: string;
  openingBalanceDate?: string;
  openingBalanceCashAmount?: number;
  openingBalanceBankAmount?: number;
  onaceTimeShowOpeningBalnce?: boolean;
  totalReceivePaymentTitle: string;
}) => {
  let totalCashAmount = 0;
  let totalBankAmount = 0;
  return (
    <TableContainer sx={{ border: '1px solid #ddd', borderRadius: '4px' }}>
      <Table sx={{ borderCollapse: 'collapse' }}>
        <TableRow sx={{ borderBottom: '1px solid #ddd' }}>
          <TableCell
            colSpan={3}
            sx={{
              fontSize: '11px',
              fontWeight: 'bold',
              padding: '2px 5px',
              borderRight: '1px solid #ddd',
              '&:last-child': { borderRight: 'none' },
            }}
          >
            {crOrDr}
          </TableCell>

          <TableCell
            sx={{
              fontSize: '10px',
              padding: '2px 5px',
              borderRight: '1px solid #ddd',
              '&:last-child': { borderRight: 'none' },
            }}
          >
            <Typography
              variant='h6'
              sx={{
                textAlign: 'center',

                fontSize: '10px', // Reduced font size
                fontWeight: 'bold', // Added bold
              }}
            >
              {fromDateTodate}
            </Typography>
          </TableCell>
        </TableRow>
        <TableRow sx={{ borderBottom: '1px solid #ddd' }}>
          {tableHead?.map((table) => (
            <TableCell
              sx={{
                fontSize: '10px',
                padding: '2px 5px',
                borderRight: '1px solid #ddd',
                '&:last-child': { borderRight: 'none' },
              }}
            >
              <strong>{table}</strong>
            </TableCell>
          ))}
        </TableRow>

        <TableBody>
          {onaceTimeShowOpeningBalnce && (
            <TableRow sx={{ borderBottom: '1px solid #ddd' }}>
              <TableCell
                colSpan={3}
                style={{
                  fontSize: '10px',
                  fontWeight: 'bold',
                  whiteSpace: 'nowrap',
                  padding: '3px 4px',
                  borderRight: '1px solid #ddd',
                }}
              >
                {openingBalanceDate}
              </TableCell>
              <TableCell
                style={{
                  fontSize: '10px',
                  fontWeight: 'bold',
                  padding: '3px 4px',
                  whiteSpace: 'nowrap',
                  borderRight: '1px solid #ddd',
                }}
              >
                Opening Balance--
              </TableCell>
              <TableCell
                style={{
                  fontSize: '10px',
                  fontWeight: 'bold',
                  whiteSpace: 'nowrap',
                  padding: '4px 8px',
                  borderRight: '1px solid #ddd',
                }}
              >
                {openingBalanceCashAmount}
              </TableCell>
              <TableCell
                style={{
                  fontSize: '10px',
                  fontWeight: 'bold',
                  whiteSpace: 'nowrap',
                  padding: '4px 8px',
                  borderRight: '1px solid #ddd',
                }}
              >
                {openingBalanceBankAmount}
              </TableCell>
            </TableRow>
          )}

          {data?.length &&
            data?.map((row, index, arr) => {
              row.payment_method === 'Bank'
                ? (totalBankAmount += Number(row.amount))
                : 0;
              row.payment_method === 'Cash'
                ? (totalCashAmount += Number(row.amount))
                : 0;
              return (
                <>
                  <TableRow key={index} sx={{ borderBottom: '1px solid #ddd' }}>
                    <TableCell
                      style={{
                        fontSize: '11px',
                        whiteSpace: 'nowrap',
                        padding: '4px 8px',
                        borderRight: '1px solid #ddd',
                      }}
                    >
                      {dayjs(row.money_receipt_date).format('DD-MM-YYYY')}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: '11px',
                        padding: '4px 8px',
                        borderRight: '1px solid #ddd',
                      }}
                    >
                      {row.voucher_no}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: '11px',
                        padding: '4px 8px',
                        borderRight: '1px solid #ddd',
                      }}
                    >
                      {row.cheque_number}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: '11px',
                        padding: '4px 8px',
                        borderRight: '1px solid #ddd',
                      }}
                    >
                      {row.description}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: '11px',
                        textAlign: 'right',
                        padding: '4px 8px',
                        borderRight: '1px solid #ddd',
                      }}
                    >
                      {row.payment_method === 'Cash' ? row.amount : '-'}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: '11px',
                        textAlign: 'right',
                        padding: '4px 8px',
                      }}
                    >
                      {row.payment_method === 'Bank' ? row.amount : '-'}
                    </TableCell>
                  </TableRow>
                  {arr?.length === index + 1 && (
                    //always show last index
                    <TableRow>
                      <TableCell
                        style={{
                          whiteSpace: 'nowrap',
                          padding: '4px 8px',
                          borderRight: '1px solid #ddd',
                        }}
                        colSpan={3}
                      ></TableCell>
                      <TableCell
                        style={{
                          whiteSpace: 'nowrap',
                          padding: '4px 8px',
                          borderRight: '1px solid #ddd',
                        }}
                      >
                        {totalReceivePaymentTitle}
                      </TableCell>
                      <TableCell
                        style={{
                          whiteSpace: 'nowrap',
                          padding: '4px 8px',
                          borderRight: '1px solid #ddd',
                        }}
                        align='right'
                      >
                        {totalCashAmount}
                      </TableCell>
                      <TableCell
                        style={{
                          whiteSpace: 'nowrap',
                          padding: '4px 8px',
                          borderRight: '1px solid #ddd',
                        }}
                        align='right'
                      >
                        {totalBankAmount}
                      </TableCell>
                    </TableRow>
                  )}
                </>
              );
            })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PrintReceivePaymentCommonCom;
